<template>
  <div class="mod-home">
    <div class="top-content">
      <div class="intro">
        <h1>小接口 大力量<br>全方位实现自动化营销管理</h1>
        <p>1.本地远程操作广告投放，效率更高</p>
        <p>2.广告优化探索更自由，差异化赋能客户</p>
        <a 
          class="btn-item"
          href="#detail"
        >
          了解更多
        </a>
      </div>
      <i class="icon-home" />
    </div>
    <div class="data-box">
      <div class="data-title-box">
        <p>趣智营销</p>
        <h2>Marketing API</h2>
      </div>
      <div 
        v-for="item in datas"
        :key="item.key"
        class="data-item"
      >
        <h2>{{ dataInfo[item.key] || 0 }}</h2>
        <span>{{ item.label }}</span>
      </div>
    </div>
    <div 
      id="detail"
      class="detail-box"
    >
      <h1>四大功能助力提升</h1>
      <p>账号管理 广告投放 数据报表 DMP人群管理</p>
      <ul class="details">
        <li 
          v-for="(item, index) in details"
          :key="index"
          class="detail-item"
        >
          <i :class="item.icon" />
          <h5>{{ item.title }}</h5>
          <span>{{ item.desc }}</span>
        </li>
      </ul>
    </div>
    <ul class="function-box">
      <li 
        v-for="(item, index) in functions"
        :key="index"
        class="function-item"
      >
        <i :class="item.icon" />
        <div class="function-content">
          <h2>{{ item.title }}</h2>
          <p 
            v-for="(d, j) in item.desc"
            :key="j"
          >
            {{ d }}
          </p>
        </div>
      </li>
    </ul>
    <div class="case-box">
      <el-carousel indicator-position="outside">
        <el-carousel-item 
          v-for="(item, index) in cases" 
          :key="index"
          class="case-item"
        >
          <p
            v-for="(d, j) in item.content"
            :key="j" 
            class="case-content"
          >
            {{ d }}
          </p>
          <h5 class="case-title">{{ item.title }}</h5>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
import { getDataInfo } from '@/service';
export default {
  data() {
    return {
      dataInfo: {},
      datas: [
        {
          key: 'company',
          label: '接入团队',
        },
        {
          key: 'app',
          label: '接入应用',
        },
        {
          key: 'account',
          label: '接入账户',
        },
      ],
      details: [
        {
          icon: 'icon-phone',
          title: '效率提升',
          desc:
            '接口批量搭建投放计划，配置投放单元，上传广告物料，节约大量人力。',
        },
        {
          icon: 'icon-fire',
          title: '效果提升',
          desc:
            '底层数据打通，加速决策（及时暂停低质广告）；多平台优质素材本地同传，放大投放优势。',
        },
        {
          icon: 'icon-extend',
          title: '业务扩展',
          desc:
            '支持开发自动工具监测计划效果，功能拓展更多提效工具，优化空间更大。',
        },
        {
          icon: 'icon-check',
          title: '数据保障',
          desc:
            '数据实时读取，存储，处理，人群包本地直接调取定向，数据更安全。',
        },
      ],
      functions: [
        {
          icon: 'icon-accounts',
          title: '多账户高效管理',
          desc: [
            '客户有多个广告主账号，管理不同的广告主或数据导出等操作需要频繁切换广告主账号，非常浪费时间。',
            '客户通过Marketing API对接精准获取广告主信息，不用登录投放平台即可管理所有广告主账号，大大提高了工作效率。',
          ],
        },
        {
          icon: 'icon-actual',
          title: '实时操作广告投放',
          desc: [
            '该客户有很多广告计划，客户需要实时查看广告计划、单元、创意、素材的状态和信息，每次都需要进入后台操作，花很多时间在账户登录上。',
            '客户对接Marketing API ，能够实时精准获取广告计划、单元、创意、素材的的全部字段信息，并支持增删改，减少了人工登录操作时间，提升了优化效率。',
          ],
        },
        {
          icon: 'icon-datas',
          title: '获取数据报表',
          desc: [
            '客户每天要用至少3个小时时间做数据整理和分析，但客户想看到的更加细致的信息，包括付费用户的来源、人群特征和前端投放数据与后端转化数据关系等。',
            '客户对接Marketing API ，实现一些定制化的报表，如按创意维度分析不同定向效果的报表、分广告位的后端转化报表、自动化投放日报、周报、自动推送等。',
          ],
        },
        {
          icon: 'icon-adv',
          title: '账户批量管理',
          desc: [
            '对于拥有多个广告主账户的客户来说，对于跨账户的多条计划，多个单元，多个创意的物料上传，预算修改，出价调整，状态调整等同等操作，会花费非常多的人力。',
            '通过Marketing API对接实现跨账户对广告计划/广告单元/广告创意全部字段进行批量修改，包括站点和点击监控链接，大大提高了全局工作效率，更快速地完成账户优化调整。',
          ],
        },
        {
          icon: 'icon-dmp',
          title: '管理DMP人群包',
          desc: [
            '客户使用DMP上传人群包时，需要定时上传新的人群包进行更新，多账户投放时过程繁琐。',
            '通过Marketing API实现人群包自动更新，通过与客户系统打通，客户可以实现人群数据的自动更新，如增加排除/定向人群，无需手动操作。',
          ],
        },
      ],
      cases: [
        {
          title: '广告投放管理',
          content: [
            '某代理商面临着产品多，任务重，操作繁琐，效率难以提升的困境。',
            '在不增加优化师人力的情况下，无法大幅增加广告投放数量，导致陷入增长瓶颈。 但在接入mkt-api后，借助一站式智能广告投放平台。',
            '通过全账户同步管理，批量创建广告，在线管理创意素材，人群包自动更新，自动投放管理等mkt-api等独有功能大大缩减了投放的人力。',
            '在接入mkt-api三期前后，该团队每日管理的广告账户增加了8倍。消耗量增长2倍，创意数增长3倍。',
          ],
        },
        {
          title: '广告数据拉取',
          content: [
            '公司优化师都需要对大量客户的投放数据进行分析和汇报。由于大量账户需要不断切换下载，每日都要耗费大量人力在繁琐枯燥的数据报表下载中。',
            'Mkt-api替该公司解决了这一痛点，该公司根据其实际业务需求，定制了数据监控平台，全方位多维度地提供数据分析报表，对广告计划、单元等多层次广告数据分小时分天进行查询。所有数据报表都支持批量导出。优化师的人力得到解放，所有后续的广告投放提供更强大的指导。提高人效500%， 服务客户数35+， 消耗增加200%.',
          ],
        },
      ],
    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const res = await getDataInfo();
      this.dataInfo = res.data;
    },
  },
};
</script>

<style lang="scss" scoped>
$max-width: 960px;

.mod-home {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 83px;
  font-family: 'Nunito', sans-serif;
  .top-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 20px 100px;
    box-sizing: border-box;
    .intro {
      margin-right: 120px;
      color: #fff;
      > h1 {
        margin-bottom: 15px;
        font-size: 2.5rem;
        font-weight: 700;
        line-height: 54px;
      }
      > p {
        color: rgba(255, 255, 255, 0.8);
        font-weight: 500;
        line-height: 32px;
        font-size: 18px;
      }
      .btn-item {
        display: inline-block;
        margin-top: 35px;
        line-height: 24px;
        font-size: 16px;
        font-weight: 600;
        border-radius: 30px;
        padding: 12px 30px;
        box-shadow: 0 0 30px rgba(252, 189, 37, 0.4);
        background-color: #ffa426;
        border-color: #ffa426;
        color: #fff;
      }
    }
    .icon-home {
      display: inline-block;
      width: 633px;
      height: 464px;
      background-image: url('./images/bg_home.png');
      background-size: 100%;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  .data-box {
    display: flex;
    align-items: center;
    width: $max-width;
    height: 70px;
    margin: 0 auto;
    background-color: #fff;
    box-shadow: 0 0 25px rgba(103, 119, 239, 0.1);
    margin-top: 50px;
    border-radius: 3px;
    padding: 60px 50px;
    .data-title-box {
      flex-grow: 1;
      h2 {
        font-size: 2rem;
        font-weight: 700px;
      }
      > p {
        font-weight: 500;
        color: #98a6ad;
        font-size: 14px;
        letter-spacing: 2px;
      }
      > h2 {
        &:after {
          content: ' ';
          border-radius: 5px;
          height: 8px;
          width: 50px;
          background-color: $primary-color;
          display: inline-block;
          float: left;
          margin-top: 20px;
          margin-right: 15px;
        }
      }
    }
    .data-item {
      width: 150px;
      margin-left: 30px;
      text-align: center;
      > h2 {
        margin-bottom: 8px;
      }
      > span {
        font-weight: 700;
        color: $primary-color;
        font-size: 14px;
        letter-spacing: 2px;
      }
    }
  }
  .detail-box {
    padding-top: 120px;
    > h1 {
      font-size: 28px;
      line-height: 34px;
      font-weight: 700;
      color: $primary-color;
      text-align: center;
    }
    > p {
      margin-top: 20px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.5);
      font-size: 18px;
      line-height: 30px;
      text-align: center;
    }
    .details {
      display: flex;
      justify-content: space-between;
      width: $max-width;
      margin: 50px auto 0;
      .detail-item {
        display: flex;
        flex-direction: column;
        width: 20%;
        > i {
          display: inline-block;
          width: 50px;
          height: 50px;
          border-radius: 50%;
          background-color: rgba(103, 119, 239, 0.1);
          background-size: 24px;
          background-position: center;
          background-repeat: no-repeat;
          &.icon-phone {
            background-image: url('./images/icon_phone.svg');
          }
          &.icon-fire {
            background-image: url('./images/icon_fire.svg');
          }
          &.icon-extend {
            background-image: url('./images/icon_extend.svg');
          }
          &.icon-check {
            background-image: url('./images/icon_check.svg');
          }
        }
        > h5 {
          margin-top: 20px;
          font-weight: 700;
          font-size: 1.25rem;
          line-height: 1.2;
        }
        > span {
          margin-top: 10px;
          line-height: 32px;
          color: #4e5051;
          font-size: 16px;
          font-weight: 400;
        }
      }
    }
  }
  .function-box {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin-top: 120px;
    box-sizing: border-box;
    .function-item {
      display: flex;
      align-items: center;
      position: relative;
      box-sizing: border-box;
      overflow: hidden;
      &:nth-child(2n) {
        flex-direction: row-reverse;
        padding-left: 240px;
        &:after {
          content: ' ';
          position: absolute;
          right: 0;
          top: 0;
          width: 36%;
          height: 500px;
          border-radius: 50% 20% 30% 50%;
          background-image: linear-gradient(to bottom, #034bbf, $primary-color);
          transform: skewY(20deg) skewX(-22deg);
          z-index: -1;
        }
      }
      &:nth-child(2n + 1) {
        padding-right: 240px;
        &:after {
          content: ' ';
          position: absolute;
          top: 0;
          left: 0;
          width: 36%;
          height: 500px;
          border-radius: 20% 50% 50% 30%;
          background-image: linear-gradient(to bottom, #034bbf, $primary-color);
          transform: skewY(20deg) skewX(-22deg);
          z-index: -1;
        }
      }
      > i {
        flex-shrink: 0;
        display: inline-block;
        width: 500px;
        height: 500px;
        margin: 0 50px;
        background-repeat: no-repeat;
        background-position: center;
        &.icon-accounts {
          background-image: url('./images/icon_accounts.svg');
        }
        &.icon-actual {
          background-image: url('./images/icon_actual.svg');
        }
        &.icon-datas {
          background-image: url('./images/icon_datas.png');
        }
        &.icon-adv {
          background-image: url('./images/icon_adv.png');
        }
        &.icon-dmp {
          background-image: url('./images/icon_dmp.svg');
        }
      }
      .function-content {
        flex-grow: 1;
        > h2 {
          margin-bottom: 30px;
          font-size: 28px;
          line-height: 34px;
          font-weight: 700;
        }
        > p {
          margin-bottom: 20px;
          color: rgba(0, 0, 0, 0.5);
          font-size: 18px;
          line-height: 30px;
        }
      }
    }
  }
  .case-box {
    width: $max-width;
    margin: 120px auto 0;
    .case-item {
      display: flex;
      flex-direction: column;
      padding-top: 30px;
      color: #fff;
    }
    .case-content {
      padding: 0 60px 5px;
      font-size: 18px;
      font-style: oblique;
      font-family: 'Time new Romans';
    }
    .case-title {
      flex-grow: 1;
      margin-top: 30px;
      font-size: 30px;
      font-weight: 600;
      text-align: center;
    }
  }
}
</style>
